import React, { useMemo } from "react";
import { QRCode } from "react-qrcode-logo";
import { useTranslation } from "react-i18next";
import "./previewQRCode.scss";

interface IPreviewQRCodeProps {
  receipts_url: string;
  qrStyle?: "squares" | "dots" | "fluid";
  eyeRadius?: number;
  ecLevel?: "L" | "M" | "Q" | "H";
  quietZone?: number;
  // logo?: string;
}

export const PreviewQRCode: React.FC<IPreviewQRCodeProps> = ({
  receipts_url,
  qrStyle,
  eyeRadius,
  ecLevel,
  quietZone,
  // logo,
}) => {
  const { t } = useTranslation();

  const qrValue = useMemo(() => {
    const trimmed = receipts_url?.trim();
    if (!trimmed) {
      return " ";
    }
    return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  }, [receipts_url]);

  const totalSize = 180 + (quietZone || 15) * 2;

  return (
    <div className="preview-qr-container">
      <div className="preview-qr-inner" style={{ width: totalSize + 24, height: totalSize + 24 }}>
        <QRCode
          value={qrValue}
          // logoImage={logo}
          logoWidth={35}
          logoOpacity={1}
          removeQrCodeBehindLogo
          qrStyle={qrStyle || "dots"}
          eyeRadius={eyeRadius || 12}
          ecLevel={ecLevel || "H"}
          quietZone={quietZone || 15}
          size={180}
        />
      </div>
      <div className="preview-qr-footer">
        <p className="preview-qr-label">{t("Encoded Content")}</p>
        <p className="preview-qr-content">{qrValue}</p>
      </div>
    </div>
  );
};
